import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';

import { ACCOUNT_LIST_HEADER } from '@constants/tableheader';

/** 계정 정보 관리 > 계정 목록 스켈레톤 */
const AccountListSkeleton = () => {
  /** 테이블용 데이터 */
  const tableData = useMemo(
    () =>
      Array.from({ length: 10 })?.map((d: any, i: number) => ({
        ...d,
        id: i,
        no: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        email: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        name: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        delete: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
      })),
    []
  );
  return (
    <>
      <div css={titleStyle}>계정 정보 관리</div>
      <div css={counts}>
        <div>
          <Skeleton variant="text" width={70} />
        </div>
        <div className="buttonWrap">
          <Skeleton
            variant="rectangular"
            width={100}
            height={34}
            sx={{ borderRadius: '5px' }}
          />
        </div>
      </div>

      <Table header={ACCOUNT_LIST_HEADER} data={tableData} />
    </>
  );
};

export default AccountListSkeleton;

const counts = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 10px;
  strong {
    font-weight: 700;
  }
  .buttonWrap {
    display: flex;
    gap: 10px;
  }
`;
const items = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;
